import React from 'react'

function PreFinAdmFin() {
  return (
    <div></div>
  )
}

export default PreFinAdmFin